import type { Texture } from 'pixi.js';
import { AnimationAtlasCache } from './animation-atlas-cache';
import { tryResolveGameAssetFile, type GameTextureManifestEntry } from '@/game/assets/resolveGameAssetUrl';
import definitions from '../../../assets/world-art/animations/rest-idle.json';

export interface RestIdleDefinition {
  file: string; width: number; height: number; frames: number; frameMs: number;
  presentation?: GameTextureManifestEntry['presentation'];
}
/** Presentation loops use the caller's sole RAF time; snapshots never restart them. */
export function restIdleFrame(nowMs: number, frames: number, frameMs: number, reducedMotion = false): number {
  if (reducedMotion || frames < 2 || frameMs <= 0) return 0;
  return Math.floor(Math.max(0, nowMs) / frameMs) % frames;
}
export class RestIdleAssets extends AnimationAtlasCache {
  definition(key: string): RestIdleDefinition | undefined {
    return (definitions as Record<string, RestIdleDefinition>)[key];
  }
  get(key: string): readonly Texture[] | null {
    const d = this.definition(key), url = d && tryResolveGameAssetFile(d.file);
    if (!d || !url) return null;
    return this.requestAtlas({ url, width: d.width, height: d.height, columns: d.frames, scaleMode: 'nearest' });
  }
}
